<!-- 定义模版对象 -->
<template>
  <div class="login_container">
    <div class="login_box">
      <!-- 头像区域-->
      <!-- <div class="avatar_box">
         <img src="https://dmstest.bendamotor.cn/static/img/bg.a35c965b.jpg" alt="">
        </div> -->


      <!-- ref: form表单可以通过ref进行引用
             :model: 对整个表单进行数据的绑定
             :rules  对整个表单数据进行数据校验
        -->
      <div class="title">
        BENDA DMS
      </div>
      <el-form ref="loginFormRef" label-width="0" :rules="rules" class="login_form" :model="loginForm"
        @submit.native.prevent>
        <el-form-item prop="username">
          <el-input prefix-icon="iconfont iconuser" v-model="loginForm.username" placeholder="User name"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input prefix-icon="iconfont iconsuo" type="password" v-model="loginForm.password"
            placeholder="Password"></el-input>
        </el-form-item>

      </el-form>
      <el-button class="btn" :disabled="ifca" type="primary" @click="login" native-type="submit">Login</el-button>
      <div @click="wjmm"
        style="color: #409eff;margin-top: 20px;display: flex;    flex-direction: row-reverse;padding-right: 40px;cursor: pointer;">
       Forget password</div>
    </div>
  </div>
</template>

<!-- 定义JS变量 -->
<script>
import { login, getRouters, listAccType, getInfo } from '../../api/api'
export default {
  data () {
    return {
      loginForm: {
        // username: 'testout',
        // password: '123456'
        username: '',
        password: ''
      },
      ifca: false,
      acclist: [],
      rules: {
        username: [
          /* required 是否为必填项  message:提示信息 trigger:出发条件 */
          { required: true, message: this.$t('menu.Pleaseenter'), trigger: 'blur' },
          { min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur' }
        ],
        password: [
          /* required 是否为必填项  message:提示信息 trigger:出发条件 */
          { required: true, message: this.$t('menu.Pleaseentera '), trigger: 'blur' },
          { min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  setup () {
    useI18n()
  },
  created () {

    sessionStorage.setItem('i18n', 'en')
    sessionStorage.removeItem('Button')
    sessionStorage.removeItem('menu')
    sessionStorage.removeItem('name')
    sessionStorage.removeItem('namea')
    sessionStorage.removeItem('picaetype')
    // this.aa()
    let a = this.$route.query.token;
    console.log(a);
    if (a !== undefined && a.length > 0) {
      console.log(2);
      sessionStorage.setItem("token", a)

      sessionStorage.setItem("lognum", 1)
      //5.登录成功之后,跳转到/home页面中
      this.acc()
        this.info()
      this.aacbc()
    
      // this.$router.push("/index")
    }

  },
  methods: {
    reset () {

      /* $refs
          1.$从vue对象中获取数据
          2.从vue组件对象中获取全部ref标签 */
      // this.$refs.loginFormRef.resetFields()
    },
    async aacbc () {
      let param = new URLSearchParams();
      const { data: res } = await getRouters(param)
      let a = res.data
      let b = []
      let c = []
      a.forEach((e, i) => {
        if (i <= a.length - 1 && e.hidden == false) {
          b.push(e)
        }

        if (i == a.length - 1) {
          if (e.children !== undefined) {
            e.children.forEach(z => {
              if (z.hidden == false) {
                c.push(z.name)
              }

            })

          }


        }
      });
      console.log(123, c);

      sessionStorage.removeItem('Button')
      sessionStorage.removeItem('menu')
      sessionStorage.setItem('Button', JSON.stringify(c))
      sessionStorage.setItem('menu', JSON.stringify(b))
      this.$router.push("/index")
    },
      wjmm(){
          this.$alert('Please contact the customer service.', 'Instruction', {
          confirmButtonText: 'Confirm',
          callback: action => {
           
          }
        });
      },
    async info () {
      let param = new URLSearchParams();
      const { data: res } = await getInfo(param)
      
       sessionStorage.setItem("platform",res.user.platform)//0:运营平台 , 1:经销商平台 , 2:零售商平台
      this.acclist.forEach(e => {
       
          
        if (e.id == res.user.dealers[0].accTypeIdLs&&res.user.platform=='2') {
          sessionStorage.removeItem('shbz')
           sessionStorage.removeItem("mrid") 
          sessionStorage.setItem("shbz", e.currencyType)
          sessionStorage.setItem("mrid", e.id)
        

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
          if (e.id == res.user.dealers[0].accTypeIdSh&&res.user.platform!=='2') {
          sessionStorage.removeItem('shbz')
            sessionStorage.removeItem("mrid")
          sessionStorage.setItem("shbz", e.currencyType)
          sessionStorage.setItem("mrid", e.id)
        

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
         if (e.id == res.user.dealers[0].accTypeIdLs&&res.user.platform==2) {
          sessionStorage.removeItem('shbz')
           sessionStorage.removeItem("mrid")
          sessionStorage.setItem("shbz", e.currencyType)
          sessionStorage.setItem("mrid", e.id)
        

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
          if (e.id == res.user.dealers[0].accTypeIdSh&&res.user.platform!==2) {
          sessionStorage.removeItem('shbz')
            sessionStorage.removeItem("mrid")
          sessionStorage.setItem("shbz", e.currencyType)
          sessionStorage.setItem("mrid", e.id)
        

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
      })
      // sessionStorage.setItem("token", res.token)
      // sessionStorage.setItem("userName", this.loginForm.username)
   
      

      sessionStorage.setItem("userName", res.user.userName)
      sessionStorage.setItem("userId", res.user.dealers[0].id)
      sessionStorage.setItem("roles", res.user.roles[0].roleName)
      let bdf = ''
      let adsa =sessionStorage.getItem("platform")
      if(adsa=='2'){
        bdf=res.user.dealers[0].accTypeIdLs
      }else{
        bdf=res.user.dealers[0].accTypeIdSh
      }
  sessionStorage.setItem("accTypeIdLs", bdf)

    },
    async acc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
      this.acclist = res.data
      // sessionStorage.setItem("token", res.token)
      // sessionStorage.setItem("userName", this.loginForm.username)


    },

    async login () {
      this.ifca = true
      //   let param = new URLSearchParams();
      //  param.append("username", this.loginForm.username);
      //    param.append("password", this.loginForm.password);
      let param = {
        username: this.loginForm.username,
        password: this.loginForm.password,
        // platform: '2',
      }
      const { data: res } = await login(param)
      if (res.code !== 200) {
        this.$message.error(res.msg)
        this.ifca = false
        return false
      }
      this.$message({
        duration: 1000,
        message: '登录成功',
        type: 'success'
      });
      // this.$message.success("登录成功!",duration:)
      sessionStorage.setItem("token", res.token)
      sessionStorage.setItem("userName", this.loginForm.username)
      sessionStorage.setItem("lognum", 1)
      //5.登录成功之后,跳转到/home页面中
      //判断接口 
     
      this.acc()

      this.info()
      this.aacbc()



      //   sessionStorage.setItem("menuList",JSON.stringify(res.data.menuList))
      //  sessionStorage.setItem("operateMenuSign",JSON.stringify(res.data.operateMenuSign))

      // this.$store.state.operateMenuSign=res.data.operateMenuSign


    },


  }

}
</script>

<!-- 防止组件冲突 -->
<style lang="less" scoped>
.login_container {

  height: 100%;
  background: url('../../assets/images/loginbing.jpg') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
}

.title {
  padding-left: 20px;
  font-size: 30px;
  font-weight: 600;
  margin-top: 40px;
  margin-bottom: 40px;
}

/deep/.el-input--prefix .el-input__inner {
  height: 58px;
  font-size: 18px;
}

.login_box {
  width: 400px;
  height: 450px;
  background-color: #f2f2f29e;
  /* 设定圆弧角*/
  border-radius: 10px;
  position: absolute;
  left: 70%;
  top: 50%;
  transform: translate(-50%, -50%);

  .avatar_box {
    height: 130px;
    width: 130px;
    border: 1px solid #EEEEEE;
    border-radius: 50%;
    padding: 10px;
    box-shadow: 0 0 10px #DDDDDD;
    /* 添加阴影*/
    position: absolute;
    /* 绝对定位*/
    left: 50%;
    /* 距离左侧50%*/
    transform: translate(-50%, -50%);
    /*回调50%*/
    background-color: #FFFFFF;

    img {
      height: 100%;
      width: 100%;
      border-radius: 50%;
      background-color: #EEEEEE;
    }
  }

  .btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

  }

  .login_form {

    bottom: 0;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
}

.btn {
  width: 360px;
  margin: 0 20px;
  margin-top: 30px;
  height: 50px;
  font-size: 18px;
}
</style>
